import { styled } from '@mui/material/styles';
import MaterialButton from '@mui/material/Button';
import MaterialTypography from '@mui/material/Typography';
import { defaultColors } from '../../../configs/colors';

export const StyledButton = styled(MaterialButton)`
  text-transform: uppercase;
  border-radius: 8px;

  &.extra-small-button {
    padding: 2px 4px 1px 4px;
    font-size: 0.675rem;
    min-width: auto;
    border-radius: 5px;
    line-height: 1.8;
    margin: 2px;
  }
`;

export const StyledText = styled(MaterialTypography)`
  font-family: 'Inter';
  font-size: smaller;
  font-weight: 500;
  cursor: pointer;
  color: ${defaultColors[0]};
`;